<div class="board-container">
    <div class="board-header">
        <h2 class="board-title">Markets Board</h2>
        <button nz-button nzType="primary" (click)="openCreateMarketModal()">
            <span nz-icon nzType="plus" nzTheme="outline"></span>
            Add Market
        </button>
    </div>
    <div class="board-columns" *ngIf="columnIds.length > 0">
        <!-- Unassigned column (fixed, not draggable) -->
        <div class="board-column" cdkDropList #cardList="cdkDropList" [cdkDropListId]="unassignedColumn?.id"
            [cdkDropListData]="unassignedColumn?.markets" [cdkDropListConnectedTo]="connectedLists"
            (cdkDropListDropped)="drop($event)">
            <h3 class="column-title">{{ unassignedColumn?.title }}</h3>
            <div class="column-cards">
                <div *ngFor="let card of unassignedColumn?.markets" class="board-card" cdkDrag>
                    <div class="card-content" cdkDragHandle>
                        <span class="card-title">{{ card.name | titlecase }}</span>
                        <span class="card-meta" *ngIf="card.provider">{{ card.provider }}</span>
                        <span class="card-meta">Leads: {{ card.leadCount ?? 0 }} · {{ card.penetration ?? 0 }}%</span>
                        <nz-tag *ngIf="card.active" nzColor="green">Active</nz-tag>
                    </div>
                </div>
            </div>
        </div>
        <!-- Bucket columns (draggable to reorder) -->
        <div class="board-columns-buckets" cdkDropList cdkDropListOrientation="horizontal"
            [cdkDropListData]="bucketColumns" (cdkDropListDropped)="dropColumn($event)">
            <div *ngFor="let column of bucketColumns" class="board-column" cdkDrag>
                <h3 class="column-title column-title-draggable" cdkDragHandle>
                    {{ column.title }}
                </h3>
                <div class="column-cards" cdkDropList #cardList="cdkDropList" [cdkDropListId]="column.id"
                    [cdkDropListData]="column.markets" [cdkDropListConnectedTo]="connectedLists"
                    (cdkDropListDropped)="drop($event)">
                    <div *ngFor="let card of column.markets" class="board-card" cdkDrag (click)="editCard(card)">
                        <div class="card-content" cdkDragHandle>
                            <span class="card-title">{{ card.name | titlecase }}</span>
                            <span class="card-meta" *ngIf="card.provider">{{ card.provider }}</span>
                            <span class="card-meta">Leads: {{ card.leadCount ?? 0 }} · {{ card.penetration ?? 0
                                }}%</span>
                            <nz-tag *ngIf="card.active" nzColor="green">Active</nz-tag>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="board-columns" *ngIf="columnIds.length === 0">
        <div class="board-column">
            <h3 class="column-title">No columns found</h3>
        </div>
    </div>
</div>

<nz-modal [nzVisible]="isCreateMarketModalVisible" nzTitle="Add Market" (nzOnCancel)="closeCreateMarketModal()"
    (nzOnOk)="submitCreateMarket()" [nzOkDisabled]="createMarketForm.invalid">
    <ng-container *nzModalContent>
        <form [formGroup]="createMarketForm">
            <nz-form-item>
                <nz-form-label nzRequired>Market Name</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="name" placeholder="e.g. New York City" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Provider</nz-form-label>
                <nz-form-control>
                    <nz-select formControlName="provider" nzPlaceHolder="Select provider" style="width: 100%">
                        <nz-option *ngFor="let p of providers" [nzValue]="p.name" [nzLabel]="p.name"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Lead Count</nz-form-label>
                <nz-form-control>
                    <nz-input-number formControlName="leadCount" [nzMin]="0" style="width: 100%"></nz-input-number>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Penetration</nz-form-label>
                <nz-form-control>
                    <nz-input-number formControlName="penetration" [nzMin]="0" style="width: 100%"></nz-input-number>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Offer</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="offer" placeholder="e.g. Offer 1" [required]="true" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Competition</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="competition" placeholder="e.g. Competition 1" [required]="true" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label>Active</nz-form-label>
                <nz-form-control>
                    <nz-switch formControlName="active" [nzUnCheckedValue]="false" [nzCheckedValue]="true"></nz-switch>
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>
</nz-modal>

<nz-modal [nzVisible]="isEditCardModalVisible" nzTitle="Edit Market" (nzOnCancel)="closeEditCardModal()"
    [nzFooter]="editCardFooter">
    <ng-container *nzModalContent>
        <form [formGroup]="editCardForm">
            <nz-form-item>
                <nz-form-label nzRequired>Market Name</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="name" placeholder="e.g. New York City" />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label nzRequired>Provider</nz-form-label>
                <nz-form-control>
                    <nz-select formControlName="provider" nzPlaceHolder="Select provider" style="width: 100%">
                        <nz-option *ngFor="let p of providers" [nzValue]="p.name" [nzLabel]="p.name"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label nzRequired>Lead Count</nz-form-label>
                <nz-form-control>
                    <nz-input-number formControlName="leadCount" [nzMin]="0" style="width: 100%"></nz-input-number>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label nzRequired>Penetration</nz-form-label>
                <nz-form-control>
                    <nz-input-number formControlName="penetration" [nzMin]="0" style="width: 100%"></nz-input-number>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label nzRequired>Offer</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="offer" placeholder="e.g. Offer 1" [required]="true" />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label nzRequired>Competition</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="competition" placeholder="e.g. Competition 1" [required]="true" />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label>Active</nz-form-label>
                <nz-form-control>
                    <nz-switch formControlName="active" [nzUnCheckedValue]="false" [nzCheckedValue]="true"></nz-switch>
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-container>

    <ng-template #editCardFooter>
        <button nz-button (click)="closeEditCardModal(); $event.stopPropagation()">
            Cancel
        </button>

        <button nz-button nzType="default" nzDanger (click)="deleteCard(editCardForm.value); $event.stopPropagation()">
            Delete
        </button>

        <button nz-button nzType="primary" [disabled]="editCardForm.invalid"
            (click)="submitEditCard(); $event.stopPropagation()">
            Save
        </button>
    </ng-template>
</nz-modal>